import { NavItem, NavItemAccessor } from '@billy/design-system'

import { Currency } from '../types/currency'
import { CurrencyValue } from '../types/currencyValue'

const MOST_USED_CURRENCIES_IDS = ['DKK', 'USD', 'EUR', 'GBP']

const getCurrencyItem = (currency: Currency): NavItem<CurrencyValue> => ({
  id: currency.id,
  children: currency.id,
  searchKeywords: [currency.id, currency.name],
  value: {
    ...currency,
    displayData: {
      title: currency.id,
      description: currency.name,
    },
  },
})

export const getItems = (currencies: Currency[]): NavItem<CurrencyValue>[] => {
  const currenciesMostUsed: Currency[] = []
  const currenciesOther: Currency[] = [...currencies]
  const items: NavItem<CurrencyValue>[] = []

  // Extract most used currencies from 'currenciesOther' array
  for (const currencyId of MOST_USED_CURRENCIES_IDS) {
    const currencyIndex = currenciesOther.findIndex((currency) => currency.id === currencyId)

    if (currencyIndex >= 0) {
      const mostUsedCurrency = currenciesOther.splice(currencyIndex, 1)[0]
      currenciesMostUsed.push(mostUsedCurrency)
    }
  }

  // Prepare items for most used currencies
  for (const mostUsedCurrency of currenciesMostUsed) {
    items.push(getCurrencyItem(mostUsedCurrency))
  }

  // Add a separator
  items.push({
    id: 'separator',
    accessor: NavItemAccessor.Separator,
    children: '',
    value: {} as CurrencyValue,
  })

  // Prepare items for other currencies
  for (const otherCurrency of currenciesOther) {
    items.push(getCurrencyItem(otherCurrency))
  }

  return items
}
